const usdNumber = new Intl.NumberFormat("ru-RU", {
  minimumFractionDigits: 0,
  maximumFractionDigits: 2,
});

export function roundMoney(value: number): number {
  if (!Number.isFinite(value)) return 0;
  return Math.round((value + Number.EPSILON) * 100) / 100;
}

export function formatUsd(value: number): string {
  return `$${usdNumber.format(roundMoney(value)).replace(/\u00a0/g, " ")}`;
}

export function moneyInput(value: number): string {
  return roundMoney(value).toFixed(2).replace(/\.00$/, "");
}
